namespace Ir.Components.Workbook.DrilldownListEditor {
    interface IViewModel {
        config: WorkbookConfig;
        popupConfig: any;
        listConfig: any;
        onReportTemplateClick: Function;
        callback: Function;
    }

    let drilldownList: Array<Drilldown> = [];
    let firstIndexChanged = 0;
    let listTemplateControl: DevExpress.ui.dxList;
    
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;
        this.config = params.config as WorkbookConfig;
        this.onReportTemplateClick = onReportTemplateClick;

        let reportTemplateListPopoverControl;
        this.callback = function(obj) {
            reportTemplateListPopoverControl = obj;
        }

        this.listConfig = {
            keyExpr: 'id',
            displayExpr(e: Drilldown) {
                return replaceBasicHtmlContent(e?.name);
            },
            allowItemDeleting: true,
            itemDeleteMode: 'static',
            onInitialized(e) {
                listTemplateControl = e.component;
            },
            onItemDeleted(e) {
                let itemIndex = e.itemIndex as number;
                if (itemIndex < firstIndexChanged) {
                    firstIndexChanged = itemIndex;
                }
            },
            onItemReordered({
                fromIndex, toIndex, component,
            }) {
                if (fromIndex < firstIndexChanged) {
                    firstIndexChanged = fromIndex;
                }
                if (toIndex < firstIndexChanged) {
                    firstIndexChanged = toIndex;
                }

                const [element] = drilldownList.splice(fromIndex, 1);
                // Insert the element at the toIndex
                drilldownList.splice(toIndex, 0, element);

                let order = 0;
                for (let drilldown of drilldownList) {
                    drilldown.order = order++;
                }
            },
            itemDragging: {
                allowReordering: true,
                dropFeedbackMode: 'indicate',
            },
        };
        
        let popupControl: DevExpress.ui.dxPopup;
        this.popupConfig = {
            width: 380,
            maxWidth: "100%",
            height: 400,
            maxHeight: "100%",
            container: '#newworkbookpage',
            showTitle: true,
            title: 'Edit drilldown list',
            visible: false,
            hideOnOutsideClick: true,
            showCloseButton: false,
            position: isMobile() ? undefined : {
                at: 'right bottom',
                my: 'left top',
                collision: 'fit',
            },
            onShowing(e) {
                loadDrilldown();
            },
            onInitialized(e) {
                popupControl = e.component;
                if (params.callback && typeof params.callback === "function") {
                    params.callback(popupControl);
                }
            },
            toolbarItems: [
                {
                    locateInMenu: 'auto',
                    location: 'after',
                    widget: 'dxButton',
                    toolbar: 'top',
                    options: {
                        text: 'Add',
                        icon: 'add',
                        onClick(e) {
                            reportTemplateListPopoverControl.show(e.element, drilldownList);
                        },
                    },
                }, {
                    locateInMenu: 'always',
                    widget: 'dxButton',
                    toolbar: 'top',
                    options: {
                        text: 'Undo Changes',
                        icon: 'revert',
                        onClick() {
                            loadDrilldown();
                        },
                    },
                }, {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        icon: 'save',
                        stylingMode: 'contained',
                        type: "default",
                        text: 'Save',
                        onClick(e) {
                            let detailIsNotLast = false;
                            for (let drilldown of drilldownList.slice(0, drilldownList.length - 1)) {
                                if (!drilldown.isAggregative) {
                                    DevExpress.ui.notify({ message: `The "${drilldown.name}" is a detail report and should be the last one.`, type: "error", position: { of: e.element, at: 'bottom left', my: 'top left' }, width: 400 });
                                    detailIsNotLast = true;
                                    break;
                                }
                            }
                            if (!detailIsNotLast) {
                                var valueArr = drilldownList.map(function (item) { return item.id });
                                var isDuplicate = drilldownList.some(function (item, idx) {
                                    return drilldownList.indexOf(item) != idx
                                });
                                if (isDuplicate) {
                                    DevExpress.ui.notify({ message: `Remove duplicate reports before saving.`, type: "error", position: { of: e.element, at: 'bottom left', my: 'top left' }, width: 300 });
                                }
                                else {
                                    workbook.workbookConfig.activeTabOrWidget().drilldownManager.updateDrilldownList(drilldownList, firstIndexChanged, () => { popupControl.hide(); });
                                }
                            }
                        },
                    },
                }, {
                    widget: 'dxButton',
                    toolbar: 'bottom',
                    location: 'after',
                    options: {
                        text: 'Close',
                        icon: 'remove',
                        stylingMode: 'outlined',
                        type: 'normal',
                        onClick() {
                            popupControl.hide();
                        },
                    },
                }],
        };
    }

    function onReportTemplateClick(reportTemplate: Drilldown) {
        let drilldown = new Drilldown(reportTemplate/*, true*/);
        drilldown.order = drilldownList.length + 1;
        drilldownList.push(drilldown);
        listTemplateControl.option("dataSource", drilldownList);
        listTemplateControl.option("itemDragging.data", drilldownList);
    }

    function loadDrilldown() {
        //duplicate the array and remove level 0
        drilldownList = workbook.workbookConfig.activeTabOrWidget().drilldownManager.drilldownList.slice(1).map(x => { return new Drilldown(x/*, true*/) });
        listTemplateControl.option("dataSource", drilldownList);
        listTemplateControl.option("itemDragging.data", drilldownList);
        firstIndexChanged = drilldownList.length;
    }
}